/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTenantDto
 */
export interface UpdateTenantDto {
    /**
     * テナント名
     * @type {string}
     * @memberof UpdateTenantDto
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateTenantDto interface.
 */
export function instanceOfUpdateTenantDto(value: object): value is UpdateTenantDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateTenantDtoFromJSON(json: any): UpdateTenantDto {
    return UpdateTenantDtoFromJSONTyped(json, false);
}

export function UpdateTenantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTenantDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpdateTenantDtoToJSON(json: any): UpdateTenantDto {
    return UpdateTenantDtoToJSONTyped(json, false);
}

export function UpdateTenantDtoToJSONTyped(value?: UpdateTenantDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

